import React, { useEffect } from "react";

const Monobank = ({ url, year }) => {
  useEffect(() => {
    const container = document.getElementById("frameholder");
    if (!container || !url) return;

    // Очистити попередній вміст
    container.innerHTML = "";

    // Створити iframe
    const iframe = document.createElement("iframe");
    iframe.id = "payFrame";
    iframe.title = "monopay";
    iframe.width = "600";
    iframe.height = "600";
    iframe.src = url;
    iframe.style.borderRadius = "24px";
    iframe.style.border = "none";
    iframe.allow = "payment *";

    container.appendChild(iframe);

    // Обробка повідомлень із iframe
    const listenFrame = (event) => {
      try {
        const data = JSON.parse(event.data || "{}");
        if (data.message === "close-button") {
          window.location.href = "/taxreports?year=" + year;
        }
      } catch (e) {
        console.warn("Unexpected message", e);
      }
    };

    window.addEventListener("message", listenFrame);

    return () => {
      window.removeEventListener("message", listenFrame);
      iframe.remove();
    };
  }, [url]);

  return (
      <div
          id="frameholder"
          className="iframe-container w-full flex justify-center items-center min-h-[600px] p-4"
      />
  );
};

export default Monobank;
